import { render } from "./PartView.vue?vue&type=template&id=4679a702"
import script from "./PartView.vue?vue&type=script&lang=js"
export * from "./PartView.vue?vue&type=script&lang=js"

import "./PartView.vue?vue&type=style&index=0&id=4679a702&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__